/* eslint-disable no-unused-vars */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Switch } from '../../components/ui/switch';
import {
  DollarSign, Edit2, Trash2, Save, Plus, RefreshCw, Download, Upload,
  ShoppingCart, MapPin, Building2, Briefcase, Tag, BarChart3, Settings,
  TrendingUp, TrendingDown, CheckCircle, XCircle, AlertTriangle, Eye,
  Globe, Filter, Search, Calculator, Percent, Euro, Target, Layers,
  FileSpreadsheet, FileJson, Copy, Archive, Clock, Users, Activity,
  Recycle, Loader2, Coins
} from 'lucide-react';
import axios from 'axios';
import TypesMaitresManager from '../../components/TypesMaitresManager';
import ReferentielsManager from '../../components/ReferentielsManager';
import { toast } from 'sonner';
import {
  TARIF_TYPES, TERRITOIRES, TYPES_ENTREPRISES, ACTIVITES_PROFESSIONNELLES,
} from '../GestionTarifsDemandesPubliques.constants';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const EntreprisesTab = ({ ctx }) => {
  const {
    activeTab, tarifs, tarifsParTerritoire, tarifsParType, tarifsParEntreprise,
    configParTypeBySpace, activeSpaceTarif, dirtyTypeBySpace, configParEntreprise,
    configParTerritoire, demandes, stats, loading, searchTerm, selectedTerritoire,
    selectedType, selectedStatut, tarifDialogOpen, editingTarif, statsDialogOpen,
    tarifForm, territoiresList, typesEntrepriseList, typesDemandeList, remisesPolitique,
    remisesPolitiqueLoading, viewDialogOpen, viewingDemande, demandeDialogOpen,
    editingDemande, demandeForm, programmees, programmeesLoading, tickNow,
    setActiveTab, setTarifs, setTarifsParTerritoire, setTarifsParType, setTarifsParEntreprise,
    setConfigParTypeBySpace, setActiveSpaceTarif, setDirtyTypeBySpace, setConfigParEntreprise,
    setConfigParTerritoire, setDemandes, setStats, setLoading, setSearchTerm, setSelectedTerritoire,
    setSelectedType, setSelectedStatut, setTarifDialogOpen, setEditingTarif, setStatsDialogOpen,
    setTarifForm, setTerritoiresList, setTypesEntrepriseList, setTypesDemandeList, setRemisesPolitique,
    setRemisesPolitiqueLoading, setViewDialogOpen, setViewingDemande, setDemandeDialogOpen,
    setEditingDemande, setDemandeForm, setProgrammees, setProgrammeesLoading, setTickNow,
    fetchAllData, fetchConfigTerritoires, fetchConfigTypesAllSpaces, fetchDemandes, fetchProgrammees,
    fetchStats, fetchTarifs, filteredDemandes, formatCountdown, getTerritoireInfo, getTypeInfo,
    handleAdminDeleteDemande, handleAdminDuplicateDemande, handleAdminEditDemande, handleCancelSchedule,
    handleCloneFromDefault, handleDeleteTarif, handleDuplicateTarif, handleExport, handlePublishNow,
    handleSaveAdminDemande, handleSaveAllConfigTypeSpace, handleSaveConfigEntreprise,
    handleSaveConfigTerritoire, handleSaveConfigType, handleSaveTarif, handleToggleTarif, handleViewDemande,
    loadReferentielsFromApi, loadRemisesPolitique, openEditDialog, parseActivitesFromDemande,
    resetTarifForm, saveRemisesPolitique, toggleActivite, updateConfigEntreprise, updateConfigTerritoire,
    updateConfigType, SPACES_TARIF, getAuthHeader, emptyTypeConfig,
  } = ctx;
  return (
        <TabsContent value="entreprises" className="mt-4 space-y-4">
          <ReferentielsManager
            kind="types-entreprise"
            title="Types d'entreprise"
            accentColor="purple"
            onChange={() => loadReferentielsFromApi()}
          />
          <Card className="border-0 shadow-lg">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Building2 className="h-5 w-5 text-purple-600" />
                Configuration par Type d'Entreprise
              </CardTitle>
              <CardDescription>Ajustez les prix selon la forme juridique de l'entreprise</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {TYPES_ENTREPRISES.map(entreprise => (
                  <Card key={entreprise.value} className="border shadow-md hover:shadow-lg transition-all">
                    <CardContent className="p-4">
                      <div className="flex items-center gap-2 mb-2">
                        <Building2 className="h-5 w-5 text-purple-600" />
                        <span className="font-bold">{entreprise.label}</span>
                      </div>
                      <p className="text-xs text-slate-500 mb-3">{entreprise.description}</p>
                      
                      <div className="space-y-2">
                        <div className="flex justify-between items-center">
                          <Label className="text-xs">Coefficient</Label>
                          <Input 
                            type="number" 
                            step="0.1" 
                            value={configParEntreprise[entreprise.value]?.coefficient || 1.0} 
                            onChange={(e) => updateConfigEntreprise(entreprise.value, 'coefficient', e.target.value)}
                            className="w-20 h-7 text-right" 
                          />
                        </div>
                        <div className="flex justify-between items-center">
                          <Label className="text-xs">Remise (%)</Label>
                          <Input 
                            type="number" 
                            step="1" 
                            value={configParEntreprise[entreprise.value]?.remise || 0} 
                            onChange={(e) => updateConfigEntreprise(entreprise.value, 'remise', e.target.value)}
                            className="w-20 h-7 text-right" 
                          />
                        </div>
                      </div>
                      
                      <Button 
                        className="w-full mt-3" 
                        size="sm" 
                        variant="outline"
                        onClick={() => handleSaveConfigEntreprise(entreprise.value)}
                      >
                        <Save className="h-4 w-4 mr-1" /> Sauvegarder
                      </Button>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>
  );
};

export default EntreprisesTab;
